import { io } from 'socket.io-client';

const url = (
  process.env.REACT_APP_API_URL || 'https://esolution-api.azurewebsites.net/api'
)?.replace('/api', '');

const socket = io(url);

export default socket;
